export default __webpack_public_path__ + "static/media/start.dd437b12.svg";